import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Lock, Loader2, ArrowLeft } from 'lucide-react';
import { useAuth } from '../../auth/AuthContext';

const KEY = 'mv_section_pin_ok';

export const PinGate = ({ title, children }) => {
  const { authFetch } = useAuth();
  const [ok, setOk] = useState(() => sessionStorage.getItem(KEY) === '1');
  const [pin, setPin] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  if (ok) return children;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr('');
    try {
      await authFetch('post', '/admin/section-pin', { pin });
      sessionStorage.setItem(KEY, '1');
      setOk(true);
    } catch { setErr('Wrong PIN — try again.'); setPin(''); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-[60vh] bg-slate-50 flex items-center justify-center px-4 py-10">
      <form onSubmit={submit} className="w-full max-w-xs rounded-2xl bg-white border border-slate-200 p-6 text-center space-y-4" data-testid="pin-gate">
        <Lock className="w-8 h-8 mx-auto text-[color:var(--mv-orange)]" />
        <div>
          <h1 className="font-display text-xl font-extrabold text-[color:var(--mv-navy)]">{title}</h1>
          <p className="text-sm text-slate-500">Enter the PIN to continue.</p>
        </div>
        <input type="password" inputMode="numeric" pattern="[0-9]*" autoComplete="off" autoFocus maxLength={12} value={pin}
          onChange={(e) => setPin(e.target.value.replace(/\D/g, ''))} className="w-full h-12 rounded-md border border-slate-200 text-center text-2xl tracking-[0.4em]" data-testid="pin-input" />
        {err && <div className="text-sm font-bold text-red-700" data-testid="pin-error">{err}</div>}
        <button type="submit" disabled={busy || !pin} className="w-full h-11 rounded-md bg-[color:var(--mv-navy)] text-white font-bold disabled:opacity-50 inline-flex items-center justify-center gap-2" data-testid="pin-submit">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />}Unlock
        </button>
        <Link to="/admin" className="text-sm font-bold text-slate-500 inline-flex items-center gap-1" data-testid="pin-back"><ArrowLeft className="w-4 h-4" /> Dashboard</Link>
      </form>
    </div>
  );
};
